class Select {
    constructor() {
        this.selects = document.querySelectorAll('.js-search-select');

        this.init();
    }

    init() {
        $('.js-search-select').select2({
            language: "ru",
            ajax: {
                url: '/bitrix/services/main/ajax.php?mode=class&c=ibrush:create.order&action=findLocation',
                method:'POST',
                dataType: 'json',
                delay: 1000,
                headers: {'X-Bitrix-Csrf-Token': BX.bitrix_sessid()},
                data: function (params) {
                    return {
                        q: params.term
                    };
                },
                processResults: function (response, params) {
                    if(response.status === 'success'){
                        return {
                            results: response.data.results,
                            pagination: {}
                        };
                    }

                    return {};
                },
                cache: true
            },
            placeholder: 'Выберите город',
            minimumInputLength: 2,
        });
    }
}
